// @flow

import type { WellbeingServicesState } from "./types";

export const initialState: WellbeingServicesState = {
  requestsInProgress: 0,
  schema: null,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  modals: {
    showAddModal: false,
    modalStep: 1,
    showEditModal: false,
    showEditAssignmentsModal: false,
    showDisableModal: false,
  },
  error: null,
};

export default initialState;
